import React, { useState } from 'react';
import { FaxImagePreview } from './fax-image-preview.jsx';
import { dismissFiledItem } from '../lib/fax-api';

// Elation user-facing chart URL. The API base is api.app.elationemr.com but
// the UI is at app.elationemr.com. Matches the deep-link pattern already in
// use in public/ccm-compliance.js and public/v3/src/push-modal.jsx.
function elationChartUrl(patientId) {
  if (!patientId) return null;
  return `https://app.elationemr.com/patient/${encodeURIComponent(patientId)}/`;
}

export function FaxFiledItem({ item, onChange }) {
  const extract = item.raw_extract || {};
  const pt = extract.patient || {};
  const doc = extract.document || {};
  const wouldHave = (item.written_records && item.written_records.would_have) || null;
  const nameLine = [pt.last_name, pt.first_name].filter(Boolean).join(', ') || '(no name)';
  const when = new Date(item.created_at).toLocaleString();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  let actionDesc;
  if (item.status === 'skipped_non_patient') {
    actionDesc = 'Skipped — non-patient document';
  } else if (item.shadow_only) {
    actionDesc = `Shadow only — would have ${wouldHave ? wouldHave.action : '?'}`;
  } else if (item.written_records && item.written_records.report_id) {
    actionDesc = `Filed structured report #${item.written_records.report_id}`;
  } else if (item.written_records && item.written_records.incoming_file_id) {
    actionDesc = `Filed as ${item.document_type_label || 'Misc'}`;
  } else {
    actionDesc = item.status;
  }

  const chartUrl = elationChartUrl(item.patient_id);

  async function dismiss() {
    setBusy(true); setError(null);
    try {
      await dismissFiledItem(item.elation_group_id);
      if (onChange) onChange();
    } catch (e) { setError(e.message); setBusy(false); }
  }

  return (
    <div className="fax-filed-row">
      <FaxImagePreview
        groupId={item.elation_group_id}
        imageId={item.first_image_id}
        alt={doc.one_line_summary || 'fax page'}
      />
      <div className="fax-filed-body">
        <div className="fax-filed-title">{doc.one_line_summary || '(no summary)'}</div>
        <div className="fax-filed-meta">
          <strong>{nameLine}</strong>
          {pt.dob && <> — DOB {pt.dob}</>}
          {' · '}<span className="fax-filed-action">{actionDesc}</span>
          {' · '}<span className="tabnum">{when}</span>
        </div>
        {error && <div className="fax-filed-error">Error: {error}</div>}
      </div>
      <div className="fax-filed-actions">
        {chartUrl && (
          <a
            className="btn ghost sm"
            href={chartUrl}
            target="_blank"
            rel="noopener noreferrer"
            title="Open this patient's chart in Elation"
          >
            View in EHR
          </a>
        )}
        <button
          className="btn ghost sm fax-filed-dismiss"
          onClick={dismiss}
          disabled={busy}
          title="Hide this from Recent Activity (the document stays filed in Elation)"
          aria-label="Dismiss from recent activity"
        >
          ×
        </button>
      </div>
    </div>
  );
}
